import React from 'react';

import {
    Waypoint,
} from 'react-waypoint';

import {
    SectionTitle,
} from 'wanderu-components';
import {
    localize,
} from 'wanderu-i18n';

import CARRIERS_IMAGE from 'wanderu-assets/images/carriers.png';
import DEVICE_IMAGE from 'wanderu-assets/images/iphone-carriers.png';

import TwoColumnLayout, {
    LeftColumn,
    RightColumn,
} from '../../components/TwoColumnLayout/TwoColumnLayout';

import styles from './CompareSection.scss';

class CompareSection extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: false,
        };
    }

    onEnterWaypoint = () => {
        this.setState(() => ({
            visible: true,
        }));
    };

    render() {
        const { visible } = this.state;
        const {
            className,
            t,
        } = this.props;
        const imageClass = `${styles.carriersImg} ${visible
            ? styles.visible
            : ''}`;

        return (
            <section
                aria-labelledby="gta-compare"
                className={className}
            >
                <TwoColumnLayout className={styles.compareSection}>
                    <LeftColumn className={styles.leftColumn}>
                        <img
                            alt=""
                            className={styles.deviceImg}
                            height="340"
                            src={DEVICE_IMAGE}
                            width="335"
                        />

                        <img
                            alt=""
                            className={imageClass}
                            height="360"
                            src={CARRIERS_IMAGE}
                            width="375"
                        />
                    </LeftColumn>

                    <RightColumn className={styles.rightColumn}>
                        <div className={styles.rightColumnContent}>
                            <SectionTitle
                                className={styles.title}
                                id="gta-compare"
                            >
                                {t('Compare')}
                            </SectionTitle>

                            <p className={styles.text}>
                                {t('compare-section-text')}
                            </p>

                            <hr className={styles.hr} />

                            <p className={styles.subtext}>
                                {t('compare-section-description')}
                            </p>
                        </div>
                    </RightColumn>
                </TwoColumnLayout>

                <Waypoint onEnter={this.onEnterWaypoint} />
            </section>
        );
    }
}

export { CompareSection };
export default localize(CompareSection, ['t'], 'baseApp');
